var _rect, _path, _path2, _rect2, _path3, _path4, _path5, _path6, _circle, _path7, _circle2, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeniorLivingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.3335,
    y: 0.834229,
    width: 2.66667,
    height: 5.33333,
    fill: "#BBDEFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3L30.5 9.12679V30.5H16V3Z",
    fill: "#BBDEFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.12636L16 3V30.5H1.5V9.12636Z",
    fill: "#F1F8FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 30.5,
    width: 32,
    height: 1.5,
    rx: 0.75,
    fill: "#DBEDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5525 10.3458C31.3481 10.7974 30.8189 10.9775 30.3832 10.7437L15.5847 2.80083C15.4152 2.70988 15.3485 2.49438 15.4369 2.3235C15.824 1.57549 16.7273 1.29884 17.4666 1.70195L31.1593 9.16867C31.5737 9.39463 31.7474 9.91481 31.5525 10.3458Z",
    fill: "#DBEDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.546577 9.87364C0.300076 9.39758 0.491167 8.79734 0.968004 8.5499L14.9882 1.27443C15.598 0.957948 16.3154 0.976783 16.8944 1.32448L17.9898 1.98228L1.77562 10.2665C1.32239 10.4981 0.780163 10.3248 0.546577 9.87364Z",
    fill: "#B5DCFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 20.5H26V30.5H20.5V20.5Z",
    fill: "#BBDEFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6857 17.0096H25.3143C25.3143 17.0096 26 17.1633 26 17.7781V21.6206C26 21.928 24.8 22.5427 24.8 22.5427C24.8 22.5427 24.9714 26.0778 24.8 26.5389C24.6286 27 24.1143 27 24.1143 27H21.8857C21.8857 27 21.3714 26.8463 21.0286 26.5389C20.6857 26.2315 21.0286 22.5427 21.0286 22.5427C21.0286 22.5427 20 21.928 20 21.6206V17.7781C20 16.8559 20.6857 17.0096 20.6857 17.0096Z",
    fill: "#5085C9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 14,
    r: 2,
    fill: "#5085C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68571 17.0096H11.3143C11.3143 17.0096 12 17.1633 12 17.7781V21.6206C12 21.928 10.8 22.5427 10.8 22.5427C10.8 22.5427 10.9714 26.0778 10.8 26.5389C10.6286 27 10.1143 27 10.1143 27H7.88571C7.88571 27 7.37143 26.8463 7.02857 26.5389C6.68571 26.2315 7.02857 22.5427 7.02857 22.5427C7.02857 22.5427 6 21.928 6 21.6206V17.7781C6 16.8559 6.68571 17.0096 6.68571 17.0096Z",
    fill: "#BBDEFB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 14,
    r: 2,
    fill: "#BBDEFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 27H17.1143C17.1143 27 17.6286 27 17.8 26.5389C17.9714 26.0778 17.8 22.5427 17.8 22.5427C17.8 22.5427 19 21.928 19 21.6206V17.7781C19 17.1633 18.3143 17.0096 18.3143 17.0096H16V27Z",
    fill: "#D0262E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16C17.1046 16 18 15.1046 18 14C18 12.8954 17.1046 12 16 12L16 16Z",
    fill: "#D0262E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 27H14.8857C14.8857 27 14.3714 27 14.2 26.5389C14.0286 26.0778 14.2 22.5427 14.2 22.5427C14.2 22.5427 13 21.928 13 21.6206V17.7781C13 17.1633 13.6857 17.0096 13.6857 17.0096H16V27Z",
    fill: "#F3858B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16C14.8954 16 14 15.1046 14 14C14 12.8954 14.8954 12 16 12L16 16Z",
    fill: "#F3858B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeniorLivingIcon);
export default __webpack_public_path__ + "static/media/Senior-living-icon.5438dc58fba6bfb61995f2bf75ea2383.svg";
export { ForwardRef as ReactComponent };